import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import requireLogin from "helpers/requireLogin";
import "./RoleSelect.css";

/**
 * Diagonal split landing — picks between alıcı (buyer) and satıcı (seller)
 * flows. Mirrors the "split" variant of the Claude design (orange top half,
 * green bottom half, "Bugün ne yapıyorsun?" pill in the middle).
 *
 * Renders as a full-page route at /ilan-ver, OR as the body of
 * RoleSelectModal when the host wants the same UI as a modal overlay.
 *
 * Both tiles are login-gated to mirror prod's "Almak İçin İlan Ver" flow:
 * logged-out users are bounced to /login and bounced back via
 * pageToRedirectAfterLogin once they sign in.
 */
function RoleSelect({ onClose, inModal = false }) {
  const history = useHistory();
  const isLogged = useSelector((state) => state.auth.isLogged);

  const goBuyer = () => requireLogin(history, isLogged, "/ilanOlustur");
  const goSeller = () => requireLogin(history, isLogged, "/satici/ilan-olustur");
  const close = onClose || (() => history.push("/"));

  return (
    <div className={`roleSelect${inModal ? " roleSelect--inModal" : ""}`}>
      <div className="roleSelect__close" onClick={close} aria-label="Kapat">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round">
          <path d="M6 6l12 12" />
          <path d="M6 18L18 6" />
        </svg>
      </div>

      {/* Top half — alıcı */}
      <div className="roleSelect__half roleSelect__half--buyer" onClick={goBuyer}>
        <div className="roleSelect__decor">
          <svg width="180" height="180" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.2" strokeLinecap="round">
            <circle cx="11" cy="11" r="7" />
            <path d="M21 21l-4.3-4.3" />
          </svg>
        </div>
        <div className="roleSelect__chip">
          <span className="roleSelect__dot" />
          ALIYORUM
        </div>
        <h1 className="roleSelect__title">
          Al
        </h1>
        <p className="roleSelect__sub">
          Aradığın ürünü tarif et, satıcılar sana ulaşsın.
        </p>
      </div>

      {/* Bottom half — satıcı */}
      <div className="roleSelect__half roleSelect__half--seller" onClick={goSeller}>
        <div className="roleSelect__decor roleSelect__decor--bottom">
          <svg width="180" height="180" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.2" strokeLinecap="round">
            <path d="M3 12V4h8l10 10-8 8L3 12z" />
            <circle cx="8" cy="9" r="1.2" fill="#fff" />
          </svg>
        </div>
        <div className="roleSelect__chip">
          <span className="roleSelect__dot" />
          SATIYORUM
        </div>
        <h1 className="roleSelect__title">
          Sat
        </h1>
        <p className="roleSelect__sub">
          Ürününü fotoğrafla, fiyat koy, yayınla.
        </p>
      </div>

      {/* Center pill */}
      <div className="roleSelect__pill">Bugün ne yapıyorsun?</div>
    </div>
  );
}

export default RoleSelect;
